// src/pages/admin/AdminNoivos.js

import React, { useEffect, useState } from 'react';
import {
  getTurmasNoivos, createTurmaNoivos, updateTurmaNoivos, deleteTurmaNoivos,
  getInscricoesNoivos, updateStatusNoivos,
} from '../../services/api';
import { formatDate } from '../../utils/helpers';
import Toast from '../../components/common/Toast';

const STATUS_OPTS = ['Pendente', 'Aprovado', 'Reprovado', 'Concluído'];
const initialTurma = { nome: '', dataInicio: '', dataFinal: '' };

const AdminNoivos = () => {
  const [turmas, setTurmas] = useState([]);
  const [inscricoes, setInscricoes] = useState([]);
  const [form, setForm] = useState(initialTurma);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [tab, setTab] = useState('turmas');
  const [toast, setToast] = useState(null);

  const load = () => {
    getTurmasNoivos().then(r => setTurmas(r?.data || [])).catch(() => {});
    getInscricoesNoivos().then(r => setInscricoes(r?.data || [])).catch(() => {});
  };
  useEffect(load, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await updateTurmaNoivos({ ...form, id: editId });
        setToast({ msg: 'Turma atualizada!', type: 'success' });
      } else {
        await createTurmaNoivos(form);
        setToast({ msg: 'Turma criada!', type: 'success' });
      }
      setForm(initialTurma);
      setEditId(null);
      setShowForm(false);
      load();
    } catch {
      setToast({ msg: 'Erro ao salvar turma.', type: 'error' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir esta turma?')) return;
    try {
      await deleteTurmaNoivos(id);
      setToast({ msg: 'Turma excluída.', type: 'success' });
      load();
    } catch {
      setToast({ msg: 'Erro ao excluir.', type: 'error' });
    }
  };

  const handleStatus = async (id, status) => {
    try {
      await updateStatusNoivos(id, status);
      setToast({ msg: 'Status atualizado.', type: 'success' });
      load();
    } catch {
      setToast({ msg: 'Erro ao atualizar.', type: 'error' });
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h1 style={{ fontSize: '1.5rem' }}>Curso de Noivos</h1>
        <button className="btn btn-primary btn-sm" onClick={() => { setShowForm(true); setEditId(null); setForm(initialTurma); }}>
          + Nova Turma
        </button>
      </div>

      {showForm && (
        <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-lg)', padding: '1.5rem', boxShadow: 'var(--shadow-md)', marginBottom: '1.5rem', border: '2px solid var(--gold-pale)' }}>
          <h3 style={{ marginBottom: '1.25rem', fontSize: '1rem' }}>{editId ? 'Editar Turma' : 'Nova Turma'}</h3>
          <form onSubmit={handleSave} noValidate>
            <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label className="form-label">Nome da Turma</label>
                <input value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} className="form-input" required />
              </div>
              <div className="form-group">
                <label className="form-label">Data de Início</label>
                <input type="date" value={form.dataInicio} onChange={e => setForm(f => ({ ...f, dataInicio: e.target.value }))} className="form-input" required />
              </div>
              <div className="form-group">
                <label className="form-label">Data Final</label>
                <input type="date" value={form.dataFinal} onChange={e => setForm(f => ({ ...f, dataFinal: e.target.value }))} className="form-input" required />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn-sm" style={{ background: 'var(--gray-100)', color: 'var(--gray-600)' }}
                onClick={() => { setShowForm(false); setEditId(null); setForm(initialTurma); }}>Cancelar</button>
              <button type="submit" className="btn btn-primary btn-sm">{editId ? 'Salvar' : 'Criar Turma'}</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '1rem', borderBottom: '2px solid var(--gray-100)' }}>
        {['turmas', 'inscricoes'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            padding: '0.75rem 1.25rem', fontSize: '0.875rem', fontWeight: 600,
            color: tab === t ? 'var(--navy)' : 'var(--gray-400)',
            borderBottom: tab === t ? '2px solid var(--gold)' : '2px solid transparent',
            marginBottom: '-2px',
          }}>
            {t === 'turmas' ? '📅 Turmas' : '📋 Inscrições'}
          </button>
        ))}
      </div>

      {tab === 'turmas' && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>Nome</th><th>Início</th><th>Término</th><th>Ações</th></tr>
            </thead>
            <tbody>
              {turmas.length === 0 ? (
                <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--gray-400)' }}>Nenhuma turma.</td></tr>
              ) : turmas.map((t, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 600 }}>{t.nome}</td>
                  <td>{formatDate(t.dataInicio)}</td>
                  <td>{formatDate(t.dataFinal)}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button className="btn btn-sm btn-navy" onClick={() => { setForm({ nome: t.nome, dataInicio: t.dataInicio, dataFinal: t.dataFinal }); setEditId(t.id); setShowForm(true); }}>Editar</button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(t.id)}>Excluir</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'inscricoes' && (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr><th>Noivo</th><th>Noiva</th><th>Turma</th><th>Data</th><th>Status</th><th>Arquivos</th></tr>
            </thead>
            <tbody>
              {inscricoes.length === 0 ? (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--gray-400)' }}>Nenhuma inscrição.</td></tr>
              ) : inscricoes.map((ins, i) => (
                <tr key={i}>
                  <td><strong>{ins.nomeNoivo}</strong><div style={{ fontSize: '0.78rem', color: 'var(--gray-400)' }}>{ins.telefoneNoivo}</div></td>
                  <td>{ins.nomeNoiva}</td>
                  <td>{ins.turmaNome}</td>
                  <td>{formatDate(ins.dataCriacao)}</td>
                  <td>
                    <select value={ins.status} onChange={e => handleStatus(ins.id, e.target.value)}
                      style={{ border: '1px solid var(--gray-200)', borderRadius: 'var(--radius-sm)', padding: '0.25rem 0.5rem', fontSize: '0.8rem', cursor: 'pointer', background: 'var(--white)' }}>
                      {STATUS_OPTS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                  <td>
                    {ins.urlDocNoivo && <a href={ins.urlDocNoivo} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.78rem', color: 'var(--navy)', display: 'block' }}>📄 Noivo</a>}
                    {ins.urlDocNoiva && <a href={ins.urlDocNoiva} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.78rem', color: 'var(--navy)', display: 'block' }}>📄 Noiva</a>}
                    {ins.urlComprovante && <a href={ins.urlComprovante} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.78rem', color: 'var(--gold)', display: 'block' }}>💳 Pagto</a>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminNoivos;
